import 'reflect-metadata';

if (window.unsupportedMode) throw new Error('Your Browser is not supported!');
import './scss/App.scss';

import * as React from 'react';
import * as ReactDOMClient from 'react-dom/client';

import { devInfoStore } from '@app/Stores/DevInfoStore';
import { NotificationHandler } from './Components/ToastNotification';
import { appStore } from '@app/AppStore';
import App from './App';


const keydownHandler = (event: KeyboardEvent) => {
    appStore.isShiftKey = event.shiftKey;
    appStore.isCtrlKey = event.ctrlKey || (appStore.isMacOS && event.metaKey); // event.metaKey - On Macintosh keyboards, this is the ⌘ Command key
    if (event.keyCode === 112 || event.keyCode === 113 || event.keyCode === 114 || event.keyCode === 115) {
        event.preventDefault();
        return false;
    }

    return true;
};

const keyupHandler = (event: KeyboardEvent) => {
    appStore.isShiftKey = event.shiftKey;
    appStore.isCtrlKey = event.ctrlKey || (appStore.isMacOS && event.metaKey);
    return true;
};

document.addEventListener('keydown', keydownHandler, true);
document.addEventListener('keyup', keyupHandler, true);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const pendingErrors: any[] | null = (window as any).__pendingErrors;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
delete (window as any).__pendingErrors;
if (pendingErrors) {
    for (let i = 0; i < pendingErrors.length; i++) {
        NotificationHandler.showConsoleError(pendingErrors[i]);
    }
}

window.onerror = function () {
    NotificationHandler.showConsoleError(arguments);
};

if (devInfoStore.isDevelopment) {
    const privateError = console.error;
    console.error = function (message: string) {
        window.setTimeout(() => {
            NotificationHandler.showError(message);
        }, 0);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        privateError.apply(console, arguments as any);
    };
}

const renderCallback = () => {
    const loader = document.getElementById('react-app-loader');
    const message = document.getElementById('react-app-loader-message');
    if (loader && message) {
        appStore.appLoaderElement = loader;
        appStore.appLoaderMessageElement = message;
        loader.addEventListener('transitionend', () => {
            if (loader.classList.contains('hide')) {
                loader.classList.add('invisible');
            }
        },true);
        appStore.hideAppLoader();
    }
};

const rootEl = document.getElementById('react-app') as HTMLElement;

ReactDOMClient.createRoot(rootEl).render(<App callback={renderCallback} />);
